import s from './Skeleton.module.css';

export function Skeleton({ width = '100%', height = 16, radius }: { width?: number | string; height?: number | string; radius?: number }) {
  return <span className={s.sk} style={{ width, height, borderRadius: radius }} aria-hidden />;
}
